import React, { useState } from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  const navigate = useNavigate();
  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");
    try {
      const res = await axios.post("/api/auth/login", { username, password });
      localStorage.setItem("kskfield_auth", JSON.stringify(res.data));
      localStorage.setItem("kskfield_user", JSON.stringify(res.data.user));
      onLogin(res.data.user);
      navigate("/dashboard",{replace: true});
    } catch (e) {
      setErr("Invalid username or password");
    }
  }

  return (
    <div style={{
      height: "100vh",
      width: "100vw",
      background: "linear-gradient(120deg,#3388ff 40%,#dbeafe 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#fff",
          padding: 32,
          borderRadius: 12,
          boxShadow: "0 6px 32px #3388ff44",
          display: "flex",
          flexDirection: "column",
          minWidth: 320,
          gap: 18,
        }}
      >
        <h2 style={{ margin: 0, color: "#3388ff", fontWeight: 900 }}>Login</h2>
        <input
          type="text"
          autoFocus
          placeholder="Username"
          value={username}
          style={{ fontSize: 16, borderRadius: 6, border: "1px solid #bcd" }}
          onChange={e => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          style={{ fontSize: 16, borderRadius: 6, border: "1px solid #bcd" }}
          onChange={e => setPassword(e.target.value)}
          required
        />
        {err && <div style={{ color: "red", fontSize: 15 }}>{err}</div>}
        <button
          type="submit"
          style={{
            background: "#3388ff",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "12px 0",
            fontWeight: "bold",
            fontSize: 16,
            cursor: "pointer",
            letterSpacing: 1,
          }}
        >
          Log In
        </button>
      </form>
    </div>
  );
}
